module.exports = __webpack_public_path__ + "static/sunstar-flooring-logo-3be879ded5fcd7a379a9a2b1d0d9ea00.svg";